import React from 'react';
import { Box, Text } from 'theme-ui';

const Alert = ({ type, message }) => {
  let backgroundColor, color, borderColor;

  switch (type) {
    case 'error':
      backgroundColor = '#FFCFCF';
      color = '#E53E3E';
      borderColor = '#E53E3E';
      break;
    case 'success':
      backgroundColor = '#D1E7DD';
      color = '#0D1E1C';
      borderColor = '#11B268';
      break;
    default:
      backgroundColor = '#D1E7DD';
      color = '#0D1E1C';
      borderColor = '#11B268';
  }

  return (
    <Box
      sx={{
        backgroundColor,
        color,
        borderLeftWidth: '5px',
        borderLeftColor: borderColor,
        borderLeftStyle: 'solid',
        padding: '15px',
        marginBottom: '15px',
        fontFamily: 'ProductSansBold',
        marginLeft: 'auto', // Aligns the alert to the right side
        animation: 'slideIn 0.5s ease-in-out', // Add slide-in animation
        '@keyframes slideIn': { // Define the keyframes for slide-in animation
          from: { transform: 'translateY(-100%)', opacity: 0 },
          to: { transform: 'translateY(0)', opacity: 1 }
        }
      }}
    >
      <Text sx={{ fontFamily: 'ProductSansBold', textAlign: 'center', fontSize: '16px' }}>{message}</Text>
    </Box>
  );
};

export default Alert;
